import { Component, OnInit } from '@angular/core';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { NzMessageService } from 'ng-zorro-antd/message';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatomoTracker } from 'ngx-matomo';
import { LayoutComponent } from 'src/app/layout/layout.component';
import { AppConfigService } from 'src/app/shared/service/app-config.service';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { UtcToLocalPipe } from 'src/app/shared/pipes/utc-to-local.pipe';

interface ItemData {
  id: string;
  site: string;
  companyCode: string;
  supplierId: string;
  supplierName: string;
  majorEmail: string;
  majorUser: string;
  account: string;
  bindTime: Date;
  lastLogin: Date;
  expiredReason: string;
  expiredDate: Date;
  vendorMail: string;
  vendorContact: string;
  LoginUserID: string;
  // Extended optional fields for new guest vendor columns
  supplierAddress?: string;
  background?: string;
  contactChineseName?: string;
  contactEnglishName?: string;
  companyPhone?: string;
  vcfCode?: string;
  picId?: string;
  picName?: string;
}
// 分頁請求泛型與禁用 DTO
interface PagedRequest<T> { pageIndex: number; pageSize: number; data: T; }
interface DisableVendorContactDto { CompanyCode: string; VendorCode: string; MobileNumber: string; SiteNo: string; Reason?: string; }
interface DisableCustomerContactDto { UserId: string; UserName: string; CustomerCode: string; MobileNumber: string; Email: string; Reason?: string; }
interface DisableGuestVendorContactDto { UserId: string; UserName: string; GuestVendorCode: string; ContactMobile?: string; ContactEmail?: string; Reason?: string; }
interface DisableGuestCustomerContactDto { UserId: string; UserName: string; GuestCustomerCode: string; ContactMobile?: string; ContactEmail?: string; Reason?: string; }

@Component({
  selector: 'app-wmsm-DowmloadSupplierList',
  templateUrl: './wmsm-DowmloadSupplierList.component.html',
  styleUrls: ['./wmsm-DowmloadSupplierList.component.scss']
})
export class WmsmDowmloadSupplierListComponent extends BaseComponent implements OnInit {
  toNumber(value: any): number {
    return Number(value);
  }

  private isChineseText(value: string | null | undefined): boolean {
    return /[\u4e00-\u9fff]/.test(value || '');
  }

  getContactChineseName(data: any): string {
    const directValue = (data?.contactChineseName || '').toString().trim();
    if (directValue) {
      return directValue;
    }

    const vendorContact = (data?.vendorContact || '').toString().trim();
    return this.isChineseText(vendorContact) ? vendorContact : '';
  }

  // 通用防抖與搜索封裝
  private inputTimers: { [key: string]: any } = {};

  private debounceRun(key: string, fn: () => void, delay: number) {
    const t = this.inputTimers[key];
    if (t) { clearTimeout(t); }
    this.inputTimers[key] = setTimeout(fn, delay);
  }

  private autoSearch(
    type: 'guestName' | 'guestContact' | 'vendorCode' | 'vendorAccount' | 'customerCode' | 'customerName',
    value: string
  ) {
    const q = (value || '').trim();
    // 最小長度控制：編碼類至少3位；名稱/聯絡人至少1位
    const minLen = (type === 'vendorCode' || type === 'customerCode') ? 3 : 1;
    if (!q || q.length < minLen) {
      const target = this.getTargetListProp(type);
      (this as any)[target] = [];
      return;
    }
    const tab = this.toNumber(this.activeTabIndex);
    let url = '';
    let bodyData: any = {};
    switch (type) {
      case 'guestName': {
        if (!(tab === 0 || tab === 1)) return;
        const isGuestVendor = tab === 0;
        url = isGuestVendor
          ? `${this.Environment.authConfig.wmsmUrl}${URLConst.GetGuestVendorAccounts.url}`
          : `${this.Environment.authConfig.wmsmUrl}${URLConst.GetGuestCustomerAccounts.url}`;
        bodyData = isGuestVendor ? { vendorName: value } : { customerName: value };
        break;
      }
      case 'guestContact': {
        if (!(tab === 0 || tab === 1)) return;
        const isGuestVendor = tab === 0;
        url = isGuestVendor
          ? `${this.Environment.authConfig.wmsmUrl}${URLConst.GetGuestVendorAccounts.url}`
          : `${this.Environment.authConfig.wmsmUrl}${URLConst.GetGuestCustomerAccounts.url}`;
        bodyData = { contact: value };
        break;
      }
      case 'vendorCode': {
        if (tab !== 2) return;
        url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetVendorAccounts.url}`;
        const site = this.vendorForm.get('site')?.value || '';
        bodyData = { vendorCode: value, site };
        break;
      }
      case 'vendorAccount': {
        if (tab !== 2) return;
        url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetVendorAccounts.url}`;
        const site = this.vendorForm.get('site')?.value || '';
        bodyData = { account: value, site };
        break;
      }
      case 'customerCode': {
        if (tab !== 3) return;
        url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetCustomerAccounts.url}`;
        bodyData = { customerCode: q };
        break;
      }
      case 'customerName': {
        if (tab !== 3) return;
        url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetCustomerAccounts.url}`;
        bodyData = { customerName: q };
        break;
      }
    }
    const body: PagedRequest<any> = { pageIndex: 1, pageSize: 10, data: bodyData };
    const targetProp = this.getTargetListProp(type);
    this.webApiService.doPost(url, body).subscribe(
      (res: any) => {
        (this as any)[targetProp] = res?.status === '200' ? (res.data || []) : [];
      },
      (error) => {
        console.error(error);
        (this as any)[targetProp] = [];
      }
    );
  }

  private getTargetListProp(type: 'guestName' | 'guestContact' | 'vendorCode' | 'vendorAccount' | 'customerCode' | 'customerName'): string {
    switch (type) {
      case 'guestName': return 'vendorOptionList';
      case 'guestContact': return 'contactOptionList';
      case 'vendorCode': return 'vendorCodeOptionList';
      case 'vendorAccount': return 'accountOptionList';
      case 'customerCode': return 'customerCodeOptionList';
      case 'customerName': return 'customerNameOptionList';
    }
  }

  // Vendor/Customer Fuzzy Search
  onVendorInput(value: string): void {
    this.debounceRun('vendorInput', () => this.vendorSearch(value), 400);
  }

  vendorSearch(value: string): void {
    this.autoSearch('guestName', value);
  }

  // Contact Fuzzy Search
  onContactInput(value: string): void {
    this.debounceRun('contactInput', () => this.contactSearch(value), 600);
  }

  contactSearch(value: string): void {
    this.autoSearch('guestContact', value);
  }

  // Vendor Code Fuzzy Search (Tab 2)
  onVendorCodeInput(value: string): void {
    this.debounceRun('vendorCodeInput', () => this.vendorCodeSearch(value), 400);
  }

  vendorCodeSearch(value: string): void {
    this.autoSearch('vendorCode', value);
  }

  // Account Fuzzy Search (Tab 2)
  onAccountInput(value: string): void {
    this.debounceRun('accountInput', () => this.accountSearch(value), 400);
  }

  accountSearch(value: string): void {
    this.autoSearch('vendorAccount', value);
  }

  // Customer Code Fuzzy Search (Tab 3)
  onCustomerCodeInput(value: string): void {
    this.debounceRun('customerCodeInput', () => this.customerCodeSearch(value), 400);
  }

  customerCodeSearch(value: string): void {
    this.autoSearch('customerCode', value);
  }

  // Customer Name Fuzzy Search (Tab 3)
  onCustomerNameInput(value: string): void {
    this.debounceRun('customerNameInput', () => this.customerNameSearch(value), 400);
  }

  customerNameSearch(value: string): void {
    this.autoSearch('customerName', value);
  }

  // 条件区查询方法
  onSearchGuestVendor() {
    const value = this.guestVendorForm.value;
    this.fetchGuestVendorAccounts(value);
  }

  onSearchGuestCustomer() {
    const value = this.guestCustomerForm.value;
    this.fetchGuestCustomerAccounts(value);
  }

  onSearchVendor() {
    const value = this.vendorForm.value;
    this.fetchVendorAccounts(value);
  }

  onSearchCustomer() {
    const value = this.customerForm.value;
    this.fetchCustomerAccounts(value);
  }
  guestVendorForm: FormGroup;
  guestCustomerForm: FormGroup;
  vendorForm: FormGroup;
  customerForm: FormGroup;
  // 分頁參數
  pageIndexGV = 1; pageSizeGV = 10;
  pageIndexGC = 1; pageSizeGC = 10;
  pageIndexV = 1; pageSizeV = 10;
  pageIndexC = 1; pageSizeC = 10;
  // 分頁總數
  totalGV = 0; totalGC = 0; totalV = 0; totalC = 0;
  activeTabIndex: number = 0;
  guestVendorList: any[] = [];
  guestCustomerList: any[] = [];
  vendorList: any[] = [];
  customerList: any[] = [];

  // Autocomplete options
  vendorOptionList: any[] = [];
  contactOptionList: any[] = [];
  vendorCodeOptionList: any[] = [];
  accountOptionList: any[] = [];
  customerCodeOptionList: any[] = [];
  customerNameOptionList: any[] = [];
  // 已統一為 inputTimers，由 debounceRun 管理

  userId: string = '';
  // 只有Site Admin和Sys Admin 才顯示 聯絡人開關
  isShowAccountSwitch: boolean = false;

  isSpinning: boolean = false;
  get currentList() {
    switch (this.activeTabIndex) {
      case 0: return this.guestVendorList;
      case 1: return this.guestCustomerList;
      case 2: return this.vendorList;
      case 3: return this.customerList;
      default: return [];
    }
  }
  formValues: any;
  loading: boolean = false;
  switchLoadingMap: { [key: string]: boolean } = {};
  // Inline edit state for Guest Vendor VCFCode
  editingGuestVendorCode: string | null = null;
  editingGuestCustomerCode: string | null = null;
  editingVcfCode: string = '';
  editingCustomerVcfCode: string = '';
  vcfSaving: boolean = false;
  vcfCustomerSaving: boolean = false;
  // 原旧查询表单(validateForm)与分页/编辑结构已移除
  dateFormat = 'yyyy/MM/dd';
  SiteList: any;
  constructor(
    private Environment: EnvironmentconfigService,
    private webApiService: WebApiService,
    private messageService: NzMessageService,
    private fb: FormBuilder,
    private matomotracker: MatomoTracker,
    private LayoutComponent: LayoutComponent,
    private configService: AppConfigService,
    private auth: AuthService,
    private EnvironmentconfigService: EnvironmentconfigService,
    private translate: TranslateService,
    private utcToLocalPipe: UtcToLocalPipe
  ) { super() }

  ngOnInit() {
    this.guestVendorForm = this.fb.group({
      vendorCode: [''],
      vendorName: [''],
      account: [''],
      fndaAccountStatus: [''],
      accountStatus: [''],
      permissionStatus: [''],
    });
    this.guestCustomerForm = this.fb.group({
      customerCode: [''],
      customerName: [''],
      account: [''],
      fndaAccountStatus: [''],
      accountStatus: [''],
      permissionStatus: [''],
    });
    this.vendorForm = this.fb.group({
      vendorCode: [''],
      vendorName: [''],
      account: [''],
      fndaAccountStatus: [''],
      accountStatus: [''],
      permissionStatus: [''],
    });
    this.customerForm = this.fb.group({
      customerCode: [''],
      customerName: [''],
      account: [''],
      fndaAccountStatus: [''],
      accountStatus: [''],
      permissionStatus: [''],
    });
    this.setAccountSwitch();
    this.LayoutComponent.geturl()
    this.GetSiteCondition();
    this.matomotracker.trackPageView("下載供應商賬號清單");





  }

  private computeAccountStatusKey(data: any): string {
    if (data?.idmIsLock === true || data?.isLock === true) {
      return 'ContactList.AccountLocked';
    }

    if ((data?.idmIsEnable === false && !!data?.idmDisableTime) || (!data?.isenabl && !!data?.disableTime)) {
      return 'ContactList.AccountEntraInvalid';
    }

    if ((data?.idmIsEnable === false && !data?.idmEnableTime) || (!data?.isenabl && !data?.enableTime)) {
      return 'ContactList.AccountWaitingVendor';
    }

    if (data?.idmIsEnable === true || data?.isenabl === true) {
      return 'ContactList.AccountActive';
    }

    return '';
  }

  private computePermissionStatusKey(data: any): string {
    if (`${data?.status || ''}` === '2') {
      return 'ContactList.TransferredToOfficial';
    }

    return data?.isenabl ? 'ContactList.Enabled' : 'ContactList.Disabled';
  }

  private computeFndaAccountStatusKey(data: any): string {
    if (data?.idmEffectiveStatus === '已註冊 失效') {
      return 'ContactList.AccountEntraInvalid';
    }
    if (data?.idmEffectiveStatus === '待註冊') {
      return 'ContactList.AccountWaitingVendor';
    }

    if (data?.idmIsLock === true) {
      return 'ContactList.AccountLocked';
    }
    // Step 2: isenable=false & disabletime has value
    if (data?.idmIsEnable === false && !!data?.idmDisableTime) {
      return 'ContactList.AccountEntraInvalid';
    }
    // Step 3: isenable=false & enabletime is null
    if (data?.idmIsEnable === false && !data?.idmEnableTime) {
      return 'ContactList.AccountWaitingVendor';
    }
    if (data?.idmIsEnable === true) {
      return 'ContactList.AccountActive';
    }
    return '';
  }

  private getExportAccountStatusText(data: any): string {
    const key = this.computeFndaAccountStatusKey(data);
    return key ? this.translate.instant(key) : '';
  }

  // 账号开关事件（支援禁用/恢復）
  onAccountSwitch(newValue: boolean, data: any) {
    const oldValue = data.isenabl;
    if (oldValue === newValue) return;

    const key = data.supplierId + '_' + this.activeTabIndex;
    this.switchLoadingMap[key] = true;

    if (oldValue && !newValue) {
      this.disableRow(data, 'ManualDisable');
    } else if (!oldValue && newValue) {
      this.enableRow(data);

    }
  }

  ngOnDestroy() { }
  GetSiteCondition(): void {
    this.loading = true;
    const params = '';
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetSiteCondition.url}`;
    this.webApiService.doGet(url, params).subscribe(
      (res) => {
        if (res) {
          this.SiteList = res;
          //this.validateForm.controls['Site'].setValue(res[0]);
        } else {
          this.messageService.error(res.msg);
        }
        this.loading = false;
      },
      (error) => {
        this.messageService.error(error.msg);
        this.loading = false;
      }
    );
    }



  setAccountSwitch() {
    const adLoginUser = this.auth.getCurrentUserInfo();
    this.userId = adLoginUser.userId;
    const url = `${this.EnvironmentconfigService.authConfig.MVMBackEnd}${URLConst.GetUserGroupByUser.url}${adLoginUser.userId}`;
    this.webApiService.doGet(url).subscribe(res => {
      if (res.rc === 0 && res.data?.length > 0) {

        if (res.data.some(x => x.userGroupId === 17 || x.userGroupId === 23)) {
          this.isShowAccountSwitch = true;
        }
      }
    })
  }


  // ==== API 呼叫區 ====
  private fetchGuestVendorAccounts(filter: any) {
    this.loading = true;
    const body: PagedRequest<any> = { pageIndex: this.pageIndexGV, pageSize: this.pageSizeGV, data: filter };
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetGuestVendorAccounts.url}`;
    this.webApiService.doPost(url, body).subscribe((res: any) => {
      if (res.status === '200') {
        this.guestVendorList = (res.data || []).map((x: any) => ({
          ...x,
          accountStatusKey: this.computeFndaAccountStatusKey(x),
          permissionStatusKey: this.computePermissionStatusKey(x)
        }));
        this.totalGV = res.total ?? this.guestVendorList.length;
      } else {
        this.messageService.error(res.msg || '來賓廠商查詢失敗');
      }
      this.loading = false;
    }, (err: any) => { this.messageService.error(err.msg || '來賓廠商查詢失敗'); this.loading = false; });
  }

  private fetchGuestCustomerAccounts(filter: any) {
    this.loading = true;
    const body: PagedRequest<any> = { pageIndex: this.pageIndexGC, pageSize: this.pageSizeGC, data: filter };
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetGuestCustomerAccounts.url}`;
    this.webApiService.doPost(url, body).subscribe((res: any) => {
      if (res.status === '200') {
        this.guestCustomerList = (res.data || []).map((x: any) => ({
          ...x,
          accountStatusKey: this.computeFndaAccountStatusKey(x),
          permissionStatusKey: this.computePermissionStatusKey(x)
        }));
        this.totalGC = res.total ?? this.guestCustomerList.length;
      } else { this.messageService.error(res.msg || '來賓客戶查詢失敗'); }
      this.loading = false;
    }, (err: any) => { this.messageService.error(err.msg || '來賓客戶查詢失敗'); this.loading = false; });
  }

  private fetchVendorAccounts(filter: any) {
    this.loading = true;
    const body: PagedRequest<any> = { pageIndex: this.pageIndexV, pageSize: this.pageSizeV, data: filter };
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetVendorAccounts.url}`;
    this.webApiService.doPost(url, body).subscribe((res: any) => {
      if (res.status === '200') {
        this.vendorList = (res.data || []).map((x: any) => ({
          ...x,
          fndaAccountStatusKey: this.computeFndaAccountStatusKey(x),
          accountStatusKey: this.computeFndaAccountStatusKey(x),
          permissionStatusKey: this.computePermissionStatusKey(x)
        }));
        this.totalV = res.total ?? this.vendorList.length;
      } else {
        this.messageService.error(res.msg || '廠商查詢失敗');
      }
      this.loading = false;
    }, (err: any) => { this.messageService.error(err.msg || '廠商查詢失敗'); this.loading = false; });
  }

  private fetchCustomerAccounts(filter: any) {
    this.loading = true;
    const body: PagedRequest<any> = { pageIndex: this.pageIndexC, pageSize: this.pageSizeC, data: filter };
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetCustomerAccounts.url}`;
    this.webApiService.doPost(url, body).subscribe((res: any) => {
      if (res.status === '200') {
        this.customerList = (res.data || []).map((x: any) => ({
          ...x,
          accountStatusKey: this.computeFndaAccountStatusKey(x),
          permissionStatusKey: this.computePermissionStatusKey(x)
        }));
        this.totalC = res.total ?? this.customerList.length;
      } else { this.messageService.error(res.msg || '客戶查詢失敗'); }
      this.loading = false;
    }, (err: any) => { this.messageService.error(err.msg || '客戶查詢失敗'); this.loading = false; });
  }

  // 分頁事件處理
  onPageIndexChangeGV(pi: number) { this.pageIndexGV = pi; this.fetchGuestVendorAccounts(this.guestVendorForm.value); }
  onPageSizeChangeGV(ps: number) { this.pageSizeGV = ps; this.pageIndexGV = 1; this.fetchGuestVendorAccounts(this.guestVendorForm.value); }
  onPageIndexChangeGC(pi: number) { this.pageIndexGC = pi; this.fetchGuestCustomerAccounts(this.guestCustomerForm.value); }
  onPageSizeChangeGC(ps: number) { this.pageSizeGC = ps; this.pageIndexGC = 1; this.fetchGuestCustomerAccounts(this.guestCustomerForm.value); }
  onPageIndexChangeV(pi: number) { this.pageIndexV = pi; this.fetchVendorAccounts(this.vendorForm.value); }
  onPageSizeChangeV(ps: number) { this.pageSizeV = ps; this.pageIndexV = 1; this.fetchVendorAccounts(this.vendorForm.value); }
  onPageIndexChangeC(pi: number) { this.pageIndexC = pi; this.fetchCustomerAccounts(this.customerForm.value); }
  onPageSizeChangeC(ps: number) { this.pageSizeC = ps; this.pageIndexC = 1; this.fetchCustomerAccounts(this.customerForm.value); }

  // 禁用操作入口
  disableRow(row: any, reason: string) {
    switch (this.activeTabIndex) {
      case 0: return this.disableVendor(row, reason);
      case 1: return this.disableCustomer(row, reason);
      case 2: return this.disableGuestVendor(row, reason);
      case 3: return this.disableGuestCustomer(row, reason);
    }
  }

  // 啟用操作入口
  enableRow(row: any) {
    switch (this.activeTabIndex) {
      case 0: return this.enableVendor(row);
      case 1: return this.enableCustomer(row);
      case 2: return this.enableGuestVendor(row);
      case 3: return this.enableGuestCustomer(row);
    }
  }

  private disableVendor(row: any, reason: string) {
    const key = row.supplierId + '_0';
  const adLoginUser = this.auth.getCurrentUserInfo();
  const oldValue = row.isenabl;
  const body = { data: <DisableVendorContactDto>{
      CompanyCode: row.companyCode,
      VendorCode: row.supplierId,
      MobileNumber: row.account,
      SiteNo: row.siteNo || row.site,
      Reason: reason
  }};
  const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DisableVendorContact.url}`;
  this.isSpinning = true;
  this.webApiService.doPost(url, body).subscribe((res: any) => {
      this.switchLoadingMap[key] = false;

      this.isSpinning = false;
      if (res.status === '200') {
         this.messageService.success('廠商聯絡人已禁用');
          row.isenabl = false;
          // ... 其他更新 ...
      } else {
          row.isenabl = undefined!;
          setTimeout(() => {
              row.isenabl = oldValue;
          });
          this.messageService.error(res.msg || '禁用失敗');

      }

    }, (err: any) => {
      this.switchLoadingMap[key] = false;
    this.isSpinning = false;
    row.isenabl = undefined!;
      setTimeout(() => {
          row.isenabl = oldValue;
      });

    this.messageService.error(err.msg || '禁用失敗');
    });
  }

  private enableVendor(row: any) {
    const key = row.supplierId + '_0';
  const adLoginUser = this.auth.getCurrentUserInfo();
  const oldValue = row.isenabl;   // 保存原始值
  const body = { data: <DisableVendorContactDto>{
      CompanyCode: row.companyCode,
      VendorCode: row.supplierId,
      MobileNumber: row.account,
      SiteNo: row.siteNo || row.site
  }};
  const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.EnableVendorContact.url}`;
  this.isSpinning = true;
  this.webApiService.doPost(url, body).subscribe((res: any) => {
      this.switchLoadingMap[key] = false;
      this.isSpinning = false;

      if (res.status === '200') {
         this.messageService.success('廠商聯絡人已恢復');
          row.isenabl = true;
          // ... 其他成功更新 ...
      } else {
          // 失败时：强制刷新开关状态
          row.isenabl = undefined!;   // 或 null，触发变化
          setTimeout(() => {
              row.isenabl = oldValue;   // 恢复原值
          });
          this.messageService.error(res.msg || '恢復失敗');
      }
  }, (err: any) => {
    this.switchLoadingMap[key] = false;
      this.isSpinning = false;
      row.isenabl = undefined!;
      setTimeout(() => {
          row.isenabl = oldValue;
      });
      this.messageService.error(err.msg || '恢復失敗');
  });
}


  private disableCustomer(row: any, reason: string) {
    const adLoginUser = this.auth.getCurrentUserInfo();
    const body = { data: <DisableCustomerContactDto>{ UserId: adLoginUser.userId, UserName: adLoginUser.englishName, CustomerCode: row.supplierId, MobileNumber: row.account, Email: row.vendorMail, Reason: reason } };
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DisableCustomerContact.url}`;
    this.isSpinning = true;
    this.webApiService.doPost(url, body).subscribe((res: any) => {
      if (res.status === '200') {
        this.isSpinning = false;
        this.messageService.success('客戶聯絡人已禁用');
        row.isenabl = false;
        row.lastModifierId = adLoginUser.userId;
        row.lastModifierUserName = adLoginUser.userId;
        row.lastModificationTime = new Date();
        row.expiredReason = 'ManualDisable';
      } else {
        this.isSpinning = false;
        this.messageService.error(res.msg || '禁用失敗');
      }
    }, (err: any) => {
      this.isSpinning = false;
      this.messageService.error(err.msg || '禁用失敗');
    });
  }

  private enableCustomer(row: any) {
    const adLoginUser = this.auth.getCurrentUserInfo();
    const body = { data: <DisableCustomerContactDto>{ UserId: adLoginUser.userId, UserName: adLoginUser.englishName, CustomerCode: row.supplierId, MobileNumber: row.account, Email: row.vendorMail } };
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.EnableCustomerContact.url}`;
    this.isSpinning = true;
    this.webApiService.doPost(url, body).subscribe((res: any) => {
      if (res.status === '200') {
        this.isSpinning = false;
        this.messageService.success('客戶聯絡人已恢復');
        row.isenabl = true;
        row.lastModifierId = adLoginUser.userId;
        row.lastModifierUserName = adLoginUser.userId;
        row.lastModificationTime = new Date();
        row.expiredReason = '';
      } else {
        this.isSpinning = false;
        this.messageService.error(res.msg || '恢復失敗');
      }
    }, (err: any) => {
      this.isSpinning = false;
      this.messageService.error(err.msg || '恢復失敗');
    });
  }

  private disableGuestVendor(row: any, reason: string) {
    const adLoginUser = this.auth.getCurrentUserInfo();
    const body = { data: <DisableGuestVendorContactDto>{ UserId: adLoginUser.userId, UserName: adLoginUser.englishName, GuestVendorCode: row.supplierId, ContactMobile: row.vendorContact, ContactEmail: row.vendorMail, Reason: reason } };
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DisableGuestVendorContact.url}`;
    this.webApiService.doPost(url, body).subscribe((res: any) => {
      if (res.status === '200') {
        this.messageService.success('來賓廠商聯絡人已禁用');
        row.isenabl = false;
        row.status = 'D';
        row.lastModifierId = adLoginUser.userId;
        row.lastModifierName = adLoginUser.englishName;
        row.lastModificationTime = new Date();
      }
      else {
        this.messageService.error(res.msg || '禁用失敗');
      }
    }, (err: any) => this.messageService.error(err.msg || '禁用失敗'));
  }

  private enableGuestVendor(row: any) {
    const adLoginUser = this.auth.getCurrentUserInfo();
    const body = { data: <DisableGuestVendorContactDto>{ UserId: adLoginUser.userId, UserName: adLoginUser.englishName, GuestVendorCode: row.supplierId, ContactMobile: row.vendorContact, ContactEmail: row.vendorMail } };
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.EnableGuestVendorContact.url}`;
    this.webApiService.doPost(url, body).subscribe((res: any) => {
      if (res.status === '200') {
        this.messageService.success('來賓廠商聯絡人已恢復');
        row.isenabl = true;
        row.status = '1';
        row.lastModifierId = adLoginUser.userId;
        row.lastModifierName = adLoginUser.englishName;
        row.lastModificationTime = new Date();
      } else { this.messageService.error(res.msg || '恢復失敗'); }
    }, (err: any) => this.messageService.error(err.msg || '恢復失敗'));
  }

  private disableGuestCustomer(row: any, reason: string) {
    const adLoginUser = this.auth.getCurrentUserInfo();
    const body = { data: <DisableGuestCustomerContactDto>{ UserId: adLoginUser.userId, UserName: adLoginUser.englishName, GuestCustomerCode: row.supplierId, ContactMobile: row.vendorContact, ContactEmail: row.vendorMail, Reason: reason } };
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DisableGuestCustomerContact.url}`;
    this.webApiService.doPost(url, body).subscribe((res: any) => {
      if (res.status === '200') {
        this.messageService.success('來賓客戶聯絡人已禁用');
        row.isenabl = false;
        row.status = 'D';
        row.lastModifierId = adLoginUser.userId;
        row.lastModifierUserName = adLoginUser.englishName;
        row.lastModificationTime = new Date();
      } else {
        this.messageService.error(res.msg || '禁用失敗');
      }
    }, (err: any) => this.messageService.error(err.msg || '禁用失敗'));
  }

  private enableGuestCustomer(row: any) {
    const adLoginUser = this.auth.getCurrentUserInfo();
    const body = { data: <DisableGuestCustomerContactDto>{ UserId: adLoginUser.userId, UserName: adLoginUser.englishName, GuestCustomerCode: row.supplierId, ContactMobile: row.vendorContact, ContactEmail: row.vendorMail } };
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.EnableGuestCustomerContact.url}`;
    this.webApiService.doPost(url, body).subscribe((res: any) => {
      if (res.status === '200') {
        this.messageService.success('來賓客戶聯絡人已恢復');
        row.isenabl = true;
        row.status = '1';
        row.lastModifierId = adLoginUser.userId;
        row.lastModifierUserName = adLoginUser.englishName;
        row.lastModificationTime = new Date();
      }
      else {
        this.messageService.error(res.msg || '恢復失敗');
      }
    }, (err: any) => this.messageService.error(err.msg || '恢復失敗'));
  }

  // ===== 匯出功能 =====
  onExportVendor() {
    // 改為統一：先拉取全部資料，再前端生成 xlsx
    const columns = [
      { key: 'site', header: 'Site' },
      { key: 'companyCode', header: 'CompanyCode' },
      { key: 'supplierId', header: 'SupplierCode' },
      { key: 'supplierName', header: 'SupplierName' },
      { key: 'accountStatusText', header: 'AccountStatus' },
      { key: 'permissionStatusText', header: 'PermissionStatus' },
      { key: 'account', header: 'SupplierAccount' },
      { key: 'vendorContact', header: 'SupplierContact' },
      { key: 'isenabl', header: 'ContactStatus' },
      { key: 'lastLogin', header: 'LastLogInDate' },
      { key: 'creatorUserName', header: 'Creator' },
      { key: 'creationTime', header: 'CreationTime' },
      { key: 'lastModifierUserName', header: 'Modifier' },
      { key: 'lastModificationTime', header: 'ModificationTime' }
    ];
    this.exportAll(
      `${this.Environment.authConfig.wmsmUrl}${URLConst.GetVendorAccounts.url}`,
      this.vendorForm.value,
      this.totalV,
      columns,
      (item: any) => ({
        ...item,
        account: item.vendorMail || item.majorEmail || item.account,
        accountStatusText: this.getExportAccountStatusText(item),
        permissionStatusText: this.getExportPermissionStatusText(this.computePermissionStatusKey(item)),
        creatorUserName: item.creatorUserName || item.creatorId || '',
        lastLogin: this.utcToLocalPipe.transform(item.lastLogin),
      })
    );
  }

  onExportGuestVendor() {
    const columns = [
      { key: 'supplierId', header: 'GuestCode' },
      { key: 'supplierName', header: 'SupplierName' },
      { key: 'supplierAddress', header: 'SupplierAddress' },
      { key: 'background', header: 'Background' },
      { key: 'accountStatusText', header: 'AccountStatus' },
      { key: 'permissionStatusText', header: 'PermissionStatus' },
      { key: 'vendorMail', header: 'ContactEmail' },
      { key: 'vendorContact', header: 'ContactMobile' },
      { key: 'contactChineseName', header: 'ContactChineseName' },
      { key: 'contactEnglishName', header: 'ContactEnglishName' },
      { key: 'companyPhone', header: 'ContactCompanyPhone' },
      { key: 'picId', header: 'PicId' },
      { key: 'lastLogin', header: 'LastLogInDate' },
      { key: 'creatorName', header: 'Creator' },
      { key: 'creationTime', header: 'CreationTime' },
      { key: 'lastModifierName', header: 'Modifier' },
      { key: 'lastModificationTime', header: 'ModificationTime' },
      { key: 'vcfCode', header: 'VcfCode' }
    ];
    this.exportAll(
      `${this.Environment.authConfig.wmsmUrl}${URLConst.GetGuestVendorAccounts.url}`,
      this.guestVendorForm.value,
      this.totalGV,
      columns,
      (item: any) => ({
        ...item,
        accountStatusText: this.getExportAccountStatusText(item),
        permissionStatusText: this.getExportPermissionStatusText(this.computePermissionStatusKey(item)),
        creatorName: item.creatorName || item.creatorId || '',
        creationTime: this.formatExportDate(item.creationTime),
        lastLogin: this.utcToLocalPipe.transform(item.lastLogin),
        lastModificationTime: this.formatExportDate(item.lastModificationTime)
      })
    );
  }

  onExportGuestCustomer() {
    const columns = [
      { key: 'supplierId', header: 'GuestCode' },
      { key: 'supplierName', header: 'CustomerName' },
      { key: 'customerAddress', header: 'CustomerAddress' },
      { key: 'background', header: 'Background' },
      { key: 'accountStatusText', header: 'AccountStatus' },
      { key: 'permissionStatusText', header: 'PermissionStatus' },
      { key: 'account', header: 'CustomerAccount' },
      { key: 'contactChineseName', header: 'ContactChineseName' },
      { key: 'contactMobile', header: 'ContactMobile' },
      { key: 'contactEnglishName', header: 'ContactEnglishName' },
      { key: 'companyPhone', header: 'ContactCompanyPhone' },
      { key: 'lastLogin', header: 'LastLogInDate' },
      { key: 'creatorUserName', header: 'Creator' },
      { key: 'creationTime', header: 'CreationTime' },
      { key: 'lastModifierUserName', header: 'Modifier' },
      { key: 'lastModificationTime', header: 'ModificationTime' },
      { key: 'sourcer', header: 'PicId' },
      { key: 'sourcerName', header: 'PicName' },
      { key: 'vcfCode', header: 'VcfCode' }
    ];
    this.exportAll(
      `${this.Environment.authConfig.wmsmUrl}${URLConst.GetGuestCustomerAccounts.url}`,
      this.guestCustomerForm.value,
      this.totalGC,
      columns,
      (item: any) => ({
        ...item,
        accountStatusText: this.getExportAccountStatusText(item),
        permissionStatusText: this.getExportPermissionStatusText(this.computePermissionStatusKey(item)),
        creatorUserName: item.creatorUserName || item.creatorId || '',
        creationTime: this.formatExportDate(item.creationTime),
        lastLogin: this.utcToLocalPipe.transform(item.lastLogin),
        lastModificationTime: this.formatExportDate(item.lastModificationTime)
      })
    );
  }

  onExportCustomer() {
    const columns = [
      { key: 'companyCode', header: 'CompanyCode' },
      { key: 'supplierId', header: 'CustomerCode' },
      { key: 'supplierName', header: 'CustomerName' },
      { key: 'accountStatusText', header: 'AccountStatus' },
      { key: 'permissionStatusText', header: 'PermissionStatus' },
      { key: 'vendorContact', header: 'Contact' },
      { key: 'contactChineseName', header: 'ContactChineseName' },
      { key: 'companyPhone', header: 'ContactPhone' },
      { key: 'contactFax', header: 'ContactFax' },
      { key: 'account', header: 'CustomerAccount' },
      { key: 'lastLogin', header: 'LastLogInDate' },
      { key: 'creatorUserName', header: 'Creator' },
      { key: 'creationTime', header: 'CreationTime' },
      { key: 'lastModifierUserName', header: 'Modifier' },
      { key: 'lastModificationTime', header: 'ModificationTime' },
      { key: 'expiredReason', header: 'ExpiredReason' },
      { key: 'site', header: 'Site' }
    ];
    this.exportAll(
      `${this.Environment.authConfig.wmsmUrl}${URLConst.GetCustomerAccounts.url}`,
      this.customerForm.value,
      this.totalC,
      columns,
      (item: any) => ({
        ...item,
        contactChineseName: this.getContactChineseName(item),
        accountStatusText: this.getExportAccountStatusText(item),
        permissionStatusText: this.getExportPermissionStatusText(this.computePermissionStatusKey(item)),
        creatorUserName: item.creatorUserName || item.creatorId || '',
        creationTime: this.formatExportDate(item.creationTime),
        lastLogin: this.utcToLocalPipe.transform(item.lastLogin),
        lastModificationTime: this.formatExportDate(item.lastModificationTime)
      })
    );
  }

  // 通用：拉取全部資料並前端匯出
  private exportAll(
    url: string,
    formValue: any,
    total: number,
    columns: { key: string, header: string }[],
    mapper?: (row: any) => any
  ) {
    const body: PagedRequest<any> = {
      pageIndex: 1,
      pageSize: total && total > 0 ? total : 999999,
      data: formValue
    };
    this.loading = true;
    this.webApiService.doPost(url, body).subscribe((res: any) => {
      let rows = res?.data || [];
      if (mapper) {
        rows = rows.map(mapper);
      }
      this.exportListAsXlsx(rows, columns, `wmsm_SupplierList${this.getTimeString()}.xlsx`);
      this.loading = false;
    }, _ => { this.loading = false; });
  }

  private async exportListAsXlsx(rows: any[], columns: { key: string, header: string }[], filename: string) {
    if (!rows || rows.length === 0) { return; }
    try {
      this.loading = true;
      await this.ensureXlsxLoaded();
      const XLSX = (window as any).XLSX;
      const aoa = [columns.map(c => c.header)];
      for (const r of rows) {
        aoa.push(columns.map(c => this.formatCell(r[c.key])));
      }
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'SupplierList');
      XLSX.writeFile(wb, filename);
    } finally {
      this.loading = false;
    }
  }

  private xlsxLoading = false;
  private xlsxLoaded = false;
  private ensureXlsxLoaded(): Promise<void> {
    if (this.xlsxLoaded) return Promise.resolve();
    if (this.xlsxLoading) {
      return new Promise((resolve) => {
        const check = () => {
          if ((window as any).XLSX) { resolve(); }
          else { setTimeout(check, 100); }
        };
        check();
      });
    }
    this.xlsxLoading = true;
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.sheetjs.com/xlsx-latest/package/dist/xlsx.full.min.js';
      script.async = true;
      script.onload = () => { this.xlsxLoaded = true; this.xlsxLoading = false; resolve(); };
      script.onerror = () => { this.xlsxLoading = false; this.messageService.error('載入導出組件失敗'); reject(); };
      document.body.appendChild(script);
    });
  }

  private formatCell(v: any): any {
    if (v === null || v === undefined) return '';
    return typeof v === 'string' ? v : v;
  }

  private formatExportDate(value: any): string {
    if (!value) {
      return '';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return value;
    }

    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    const hours = `${date.getHours()}`.padStart(2, '0');
    const minutes = `${date.getMinutes()}`.padStart(2, '0');
    const seconds = `${date.getSeconds()}`.padStart(2, '0');
    return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
  }

  private getExportPermissionStatusText(statusKey: string): string {
    switch (statusKey) {
      case 'ContactList.TransferredToOfficial':
        return 'Transferred To Official';
      case 'ContactList.Enabled':
        return 'Enabled';
      case 'ContactList.Disabled':
        return 'Disabled';
      default:
        return '';
    }
  }

  // === Guest Vendor VCFCode inline edit handlers ===
  startEditGuestVendor(row: any) {
    this.editingGuestVendorCode = row.supplierId;
    this.editingVcfCode = row.vcfCode || '';
  }
  startEditGuestCustomer(row: any) {
    this.editingGuestCustomerCode = row.supplierId;
    this.editingCustomerVcfCode = row.vcfCode || '';
  }
  cancelEditGuestVendor() {
    this.editingGuestVendorCode = null;
    this.editingVcfCode = '';
    this.vcfSaving = false;
  }
  cancelEditGuestCustomer() {
    this.editingGuestCustomerCode = null;
    this.editingCustomerVcfCode = '';
    this.vcfCustomerSaving = false;
  }
  saveGuestVendorVcfCode(row: any) {
    const code = (this.editingVcfCode || '').trim();
    if (!code) {
      this.messageService.error('VCFCode 不可為空');
      return;
    }
    if (code.length > 10) {
      this.messageService.error('VCFCode 長度不可超過10');
      return;
    }
    const contactEmail = (row.vendorMail || '').trim().toUpperCase();
    if (!contactEmail) {
      this.messageService.error('缺少聯絡人 Email');
      return;
    }
    if (this.vcfSaving) { return; }
    this.vcfSaving = true;
    const payload = { ContactEmail: contactEmail, GuestVendorCode: row.supplierId, VCFCode: code };
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.updateGuestVendorVcfCode.url}`;
    this.webApiService.doPost(url, payload, false, true).subscribe((res: any) => {
      if (res.status === '200') {
        row.vcfCode = code;
        // Backend sets status to HandelByVCF; reflect immediately to hide the 維護 button
        row.status = 2;
        this.messageService.success('VCFCode 已更新');
        this.cancelEditGuestVendor();
      } else {
        this.messageService.error(res.msg || '更新失敗');
        this.vcfSaving = false;
      }
    }, (err: any) => { this.messageService.error(err.msg || '更新失敗'); this.vcfSaving = false; });
  }
  saveGuestCustomerVcfCode(row: any) {
    const code = (this.editingCustomerVcfCode || '').trim();
    if (!code) {
      this.messageService.error('VCFCode 不可為空');
      return;
    }
    if (this.vcfCustomerSaving) { return; }
    this.vcfCustomerSaving = true;
    const payload = { GuestCustomerCode: row.supplierId, VCFCode: code };
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateGuestCustomerVcfCode.url}`;
    this.webApiService.doPost(url, payload, false, true).subscribe((res: any) => {
      if (res.status === '200') {
        row.vcfCode = code;
        // Backend sets status to HandelByVCF; reflect immediately to hide the 維護 button
        row.status = 2;
        this.messageService.success('VCFCode 已更新');
        this.cancelEditGuestCustomer();
      } else {
        this.messageService.error(res.msg || '更新失敗');
        this.vcfCustomerSaving = false;
      }
    }, (err: any) => { this.messageService.error(err.msg || '更新失敗'); this.vcfCustomerSaving = false; });
  }
}
